import { createContext, useContext, useReducer, useEffect } from "react";

const initialState = {
  items: [],
};

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD_ITEM": {
      const { sku, quantity = 1 } = action.payload;
      const existing = state.items.find((i) => i.sku === sku);

      if (existing) {
        return {
          ...state,
          items: state.items.map((i) =>
            i.sku === sku ? { ...i, quantity: i.quantity + quantity } : i
          ),
        };
      }
      return {
        ...state,
        items: [...state.items, { ...action.payload, quantity }],
      };
    }
    case "REMOVE_ITEM":
      return {
        ...state,
        items: state.items.filter((i) => i.sku !== action.payload),
      };
    case "CLEAR_CART":
      return initialState;
    case "SET_CART":
      return { ...state, items: action.payload };

    case "INCREASE_QTY":
      return {
        ...state,
        items: state.items.map((i) =>
          i.sku === action.payload ? { ...i, quantity: i.quantity + 1 } : i
        ),
      };
    case "DECREASE_QTY":
      return {
        ...state,
        items: state.items
          .map((i) =>
            i.sku === action.payload && i.quantity > 1
              ? { ...i, quantity: i.quantity - 1 }
              : i
          )
          .filter((i) => i.quantity > 0),
      };
    default:
      return state;
  }
}

const CartContext = createContext();

export function CartProvider({ children }) {
  const [state, dispatch] = useReducer(cartReducer, initialState);

  useEffect(() => {
    const stored = localStorage.getItem("cart");
    if (stored) {
      dispatch({ type: "SET_CART", payload: JSON.parse(stored) });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(state.items));
  }, [state.items]);

  const addItem = (product, quantity = 1) =>
    dispatch({ type: "ADD_ITEM", payload: { ...product, quantity } });

  const removeItem = (sku) => dispatch({ type: "REMOVE_ITEM", payload: sku });
  const increaseQty = (sku) => dispatch({ type: "INCREASE_QTY", payload: sku });
  const decreaseQty = (sku) => dispatch({ type: "DECREASE_QTY", payload: sku });
  const clearCart = () => dispatch({ type: "CLEAR_CART" });

  return (
    <CartContext.Provider
      value={{
        items: state.items,
        addItem,
        removeItem,
        clearCart,
        increaseQty,
        decreaseQty,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
